import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AvatarComponent } from './avatar.component'
import { AnalyticsModule } from '../../shared/analytics/analytics.module'
import { ImagePipeModule } from '../../shared/pipes/image.pipe.module'
import { SvgModule } from '../../shared/svg/svg.module'

@NgModule({
  imports: [CommonModule, AnalyticsModule, ImagePipeModule, SvgModule],
  declarations: [AvatarComponent],
  exports: [AvatarComponent]
})
export class AvatarModule {}
